<template>

    <v-modal title="Copy Block?">
        <template #body>
            <p>Are you sure you want to copy this block?</p>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="dismiss">Cancel</v-button>
            <v-button size="sm" @click.native="submit">Copy Block</v-button>
        </template>
    </v-modal>

</template>

<script>

import BuilderUtil from '@builder/utils/BuilderUtil';
import Modal from './Modal';

export default {

    components: {
        'v-modal': Modal,
    },

    methods: {

        submit() {
            let blocks = this.$store.getters['builder/blocks'];
            let selectedBlock = this.$store.getters['builder/selectedBlock'];
            let selectedBlockIndex = this.$store.getters['builder/selectedBlockIndex'];
            let selectedBlockElement = BuilderUtil.getBlockElementAtIndex(selectedBlockIndex);
            // Add block element to DOM.
            let blockWrapper = selectedBlockElement.closest('.block-wrapper');
            let el = blockWrapper.cloneNode(true);
            el.classList.remove('active');
            blockWrapper.parentNode.insertBefore(el, blockWrapper.nextSibling);
            // Add block to store.
            let newBlocks = Object.assign([], blocks);
            let newBlock = JSON.parse(JSON.stringify(selectedBlock));
            newBlocks.splice(selectedBlockIndex + 1, 0, newBlock);
            this.$store.commit('builder/setBlocks', newBlocks);
            // Dismiss.
            this.dismiss();
        },

        dismiss() {
            this.$store.commit('builder/setSelectedModal', null);
        },

    },

}

</script>